import { useCallback } from 'react';
import { xrayRestClient, GetXrayOptions, GetLogBuffersOptions } from '@bymason/controller-api';
import { useGetDataHook } from '@bymason/api-hooks-base';

/**
 * React hook that asynchronously gets list of log buffers.
 * @returns HookArray
 * @HookArray [0] getLogBuffer method
 * @HookArray [1] result
 * @HookArray [2] error
 * @HookArray [3] busy flag
 * @HookArray [4] error code
 * @HookArray [5] error data
 * @HookArray [6] clearData method
 */
export function useGetLogBuffers(clientToken: string) {
  const handleGetData = useCallback(
    (options: GetLogBuffersOptions) => {
      return xrayRestClient.getLogBuffers(options, clientToken);
    },
    [clientToken]
  );

  return useGetDataHook(handleGetData);
}

/**
 * React hook that asynchronously gets screen cap of device.
 * @returns HookArray
 * @HookArray [0] getScreenCap method
 * @HookArray [1] result (blob)
 * @HookArray [2] error
 * @HookArray [3] busy flag
 * @HookArray [4] error code
 * @HookArray [5] error data
 * @HookArray [6] clearData method
 */
export function useGetScreenCap(clientToken: string) {
  const handleGetData = useCallback(
    (options: GetXrayOptions) => {
      return xrayRestClient.getScreenCap(options, clientToken);
    },
    [clientToken]
  );

  return useGetDataHook(handleGetData);
}
